import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import { IssuerSelectors } from '../pages/issuer/issuer-store/issuer-selectors';
import { catchError } from 'rxjs';
import { Router } from '@angular/router';
import { SessionTimeoutService } from 'fi-ui-common';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const sessionService = inject(SessionTimeoutService);
  let reqUrl = req.url;
  if (reqUrl.includes('{pricingMode}')) {
    const store = inject(Store);
    const pricingMode = store.selectSnapshot(IssuerSelectors.isBulkPricingMode) ? 'bulk' : 'single';
    reqUrl = reqUrl.replace('{pricingMode}', pricingMode);
  }
  const request = req.clone({
    url: environment.apiServer + reqUrl,
    withCredentials: true
  });
  return next(request).pipe(
    catchError(error => {
      if (error.status === 401 && !reqUrl.includes('user/details')) {
        sessionService.changeStatus(true);
      }

      if (error.status === 403) {
        if (error.error?.message?.includes('Cannot find user for') || error.error?.message?.includes('Cannot resolve team for')) {
          router.navigate(['/help']);
        } else {
          router.navigate(['/notAuth']);
        }
      }
      throw error;
    })
  );
};
